import { Button, Typo } from "@/components/atoms";
import { FC, memo, useCallback, useState } from "react";
import { FONT_SIZE, NATURAL } from "@/theme";
import { ServiceNotesModal, VirtualTourSurchargeModal } from "@/components/organisms";
import { BaseServiceProps } from "./OrderService.interface";
import { ORDERSERVICE_TYPE } from "@/types";
import { StyledOrderService } from "./OrderService.styled";
import { useApi } from "@/api";
import { useModal } from "@/hooks";

const OrderServiceHeader : FC<BaseServiceProps> = ({
    notificationMessage,
    notifications,
    onAskToChangeWorker,
    onNotifyCustomer,
    onRecordVirtualTour,
    selectedWorkerName,
    serviceId,
    type
}) => {

    const { worker } = useApi();
    
    const { showModal, onCloseModal, onOpenModal } = useModal();

    const { showModal: showVirtualTourModal, onCloseModal: onVirtualTourClose, onOpenModal: onVirtualTourOpen } = useModal();
  const [virtualTourPhotos, setvirtualTourPhotos] = useState<number>(0);


    const numOfNotifications = notifications?.length ?? 0;
    
    const handleOpenVirtualTourSurcharge = useCallback(() => {
        worker.getVirtualTour(serviceId).then(
            (area) => {
                setvirtualTourPhotos(area);
                onVirtualTourOpen();
            }
        )
    
    }, [serviceId]);

    const handleRecordVirtualTourSurcharge = useCallback((photos: number) => {
        onRecordVirtualTour?.(serviceId, photos);
        onVirtualTourClose();   
    }, []);

    return (
         <>
            <StyledOrderService>
                <Typo fontSize={FONT_SIZE.SM} margin="0">Photographer : <strong>{selectedWorkerName ? selectedWorkerName : '--'}</strong></Typo>
                {type === ORDERSERVICE_TYPE.VIRTUAL_TOUR && <Button buttonSize="md" buttonColor="primary" actionType="danger" onClick={handleOpenVirtualTourSurcharge}>Number of 360 images</Button> }
                {notificationMessage && <Typo fontColor={NATURAL.E} fontSize={FONT_SIZE.SM} margin="0">{notificationMessage}</Typo>}
                <Button buttonSize="md" onClick={() => onNotifyCustomer?.(serviceId)}>Notify Customer</Button>
                <Button buttonSize="md" actionType="ghost" onClick={() => onAskToChangeWorker?.(serviceId)}>Change Photographer</Button>
                <Button buttonSize="md" buttonColor={ numOfNotifications > 0 ? 'secondary' : 'primary' } actionType={ numOfNotifications > 0 ? 'danger' : 'solid' } onClick={onOpenModal}>Notes {numOfNotifications > 0 && numOfNotifications}</Button>
            </StyledOrderService>
            { showModal && <ServiceNotesModal
                isCustomer={false}
                notifications={notifications ?? []}
                onClose={onCloseModal}
                onConfirm={onCloseModal}
                orderServiceId={serviceId}
                title="Service Notes"
            /> }
            {showVirtualTourModal && (
                <VirtualTourSurchargeModal
                  virtualTourPhotos={virtualTourPhotos}
                  onClose={onVirtualTourClose}
                  onConfirm={handleRecordVirtualTourSurcharge}
                />
              )}
        </>
    );
}

export default memo(OrderServiceHeader);